interface AboutCardProps {
  version: string;
}

export function AboutCard({ version }: AboutCardProps) {
  const links = [
    { label: 'Help & Support', path: 'help' },
    { label: 'Privacy Policy', path: 'privacy' },
    { label: 'Terms of Service', path: 'terms' },
  ];

  return (
    <div className="glass rounded-3xl p-5 border border-white/10 shadow-glow-lg flex flex-col justify-between h-full text-left select-none">
      <div className="space-y-4">
        <h3 className="font-display text-sm font-black tracking-wider text-amber-300 uppercase">
          About & Legal
        </h3>

        {/* Links lists */}
        <div className="space-y-2">
          {links.map((link) => (
            <button
              key={link.label}
              onClick={() => alert(`${link.label} is prepared for legal reviews!`)}
              className="w-full glass-light px-4 py-2.5 rounded-xl border border-white/5 flex items-center justify-between text-[10px] font-black uppercase tracking-wider text-surface-300 hover:text-white transition-colors cursor-pointer"
            >
              <span>{link.label}</span>
              <span>&rarr;</span>
            </button>
          ))}
        </div>

        {/* Version label */}
        <div className="pt-2 flex items-center justify-between text-[9px] font-bold text-surface-500 uppercase tracking-widest font-mono">
          <span>Tambola Game Server</span>
          <span>Version {version}</span>
        </div>
      </div>
    </div>
  );
}
export default AboutCard;
